import { render, staticRenderFns } from "./OrderDb.vue?vue&type=template&id=445b941e&scoped=true"
import script from "./OrderDb.vue?vue&type=script&lang=js"
export * from "./OrderDb.vue?vue&type=script&lang=js"
import style0 from "./OrderDb.vue?vue&type=style&index=0&id=445b941e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445b941e",
  null
  
)

export default component.exports